module.exports = __webpack_public_path__ + "aaf5917ffed2a93594ac5f8b3110545f.svg";